import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCart } from '../../context/CartContext';
import { CartItem as CartItemType } from '../../types';
import { getImageUrl } from '../../utils/imageUrl';
import './CartItem.css';

interface CartItemProps {
  item: CartItemType;
}

const CartItem: React.FC<CartItemProps> = ({ item }) => {
  const { t, i18n } = useTranslation();
  const { updateQuantity, removeItem } = useCart();
  const { product, quantity } = item;

  const currentLang = i18n.language;
  const productName = currentLang === 'bn' ? product.name_bn : product.name_en;
  const price = product.final_price || product.price;
  const subtotal = price * quantity;

  const productImage = getImageUrl(
    product.image || product.primary_image || product.images?.[0]?.image
  );

  const handleQuantityChange = (newQuantity: number) => {
    if (newQuantity > 0 && newQuantity <= product.stock) {
      updateQuantity(product.id, newQuantity);
    }
  };

  return (
    <div className="cart-item">
      <div className="cart-item-image">
        <img src={productImage} alt={productName} />
      </div>

      <div className="cart-item-details">
        <h3>{productName}</h3>
        {product.discount_percentage > 0 && (
          <span className="discount-badge">{product.discount_percentage}%</span>
        )}
      </div>

      <div className="cart-item-price">
        ৳{price.toFixed(2)}
      </div>

      <div className="cart-item-quantity">
        <button 
          onClick={() => handleQuantityChange(quantity - 1)}
          disabled={quantity <= 1}
        >
          -
        </button>
        <span>{quantity}</span>
        <button 
          onClick={() => handleQuantityChange(quantity + 1)}
          disabled={quantity >= product.stock}
        >
          +
        </button>
      </div>

      <div className="cart-item-subtotal">
        ৳{subtotal.toFixed(2)}
      </div>

      <div className="cart-item-remove">
        <button 
          onClick={() => removeItem(product.id)}
          className="remove-btn"
          title={t('cart.remove')}
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

export default CartItem;
